module.exports = __webpack_public_path__ + "static/media/qr-code-scanning.2d90f826.gif";